<main class="san-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">Sanificazione ambienti a Pescara</h1>
            <p class="mb-0 hero-sub">
              SAMI Pulizie è specializzata nella
              <strong>sanificazione e disinfezione professionale</strong> di ambienti civili e aziendali.
              Interventi rapidi, documentati e su misura per uffici, aziende, condomini, palestre e abitazioni private.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <button class="btn-sami" (click)="navigateToPreventiviSito()">
                Richiedi preventivo gratuito
              </button>
              <a class="btn-sami-outline" href="tel:08554360">Chiama ora</a>
            </div>

            <div class="hero-chips mt-4">
              <div class="chip"><i class="fa-solid fa-shield-halved"></i> Certificata</div>
              <div class="chip"><i class="fa-solid fa-spray-can-sparkles"></i> Prodotti professionali</div>
              <div class="chip"><i class="fa-solid fa-clock"></i> Interventi rapidi</div>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/sanificazioni-trattamenti-speciali.webp"
                class="hero-img"
                alt="Sanificazione professionale - macchinari e trattamenti"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FOTO 3 -->
  <section class="section">
    <div class="container-xl">
      <div class="row g-4 align-items-start">
        <div class="col-12 col-lg-7">
          <h2 class="fw-bold mb-3">Cosa offriamo</h2>

          <p class="text-muted mb-3">
            La sanificazione professionale è fondamentale per garantire ambienti sicuri e igienizzati.
            Utilizziamo tecnologie e prodotti certificati per eliminare virus, batteri e agenti patogeni da superfici e aria.
          </p>

          <p class="text-muted mb-4">
            Ogni intervento viene documentato con rilascio di certificazione che attesta l’avvenuta sanificazione,
            utile anche per esigenze aziendali e normative.
          </p>

          <ul class="checklist">
            <li><i class="fa-solid fa-check"></i> Sanificazione con prodotti professionali certificati</li>
            <li><i class="fa-solid fa-check"></i> Trattamento di superfici e ambienti</li>
            <li><i class="fa-solid fa-check"></i> Certificazione di avvenuta sanificazione</li>
            <li><i class="fa-solid fa-check"></i> Interventi programmati o su richiesta</li>
            <li><i class="fa-solid fa-check"></i> Personale specializzato e formato</li>
            <li><i class="fa-solid fa-check"></i> Protocollo operativo su misura</li>
          </ul>
        </div>

        <div class="col-12 col-lg-5">
          <div class="card-sami p-4">
            <h3 class="fw-bold mb-3">Ambienti sanificabili</h3>
            <ul class="bullets">
              <li>Uffici e spazi aziendali</li>
              <li>Negozi e attività commerciali</li>
              <li>Studi medici e dentistici</li>
              <li>Palestre e centri sportivi</li>
              <li>Scuole e asili</li>
              <li>Condomini e aree comuni</li>
              <li>Ristoranti e bar</li>
              <li>Abitazioni private</li>
            </ul>

            <div class="mini-cta mt-3">
              <div class="mini-cta-title">Ti serve una sanificazione?</div>
              <div class="mini-cta-text">Contattaci per un intervento rapido e certificato.</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- PROCESSO -->
  <section class="section section-soft">
    <div class="container-xl">
      <div class="process-wrap card-sami">
        <h2 class="text-center fw-bold mb-4">Il nostro processo</h2>

        <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3">
          <div class="col">
            <div class="process-step">
              <div class="step-num">1</div>
              <div class="step-title">Sopralluogo</div>
              <div class="step-text">Valutiamo l’ambiente e definiamo il protocollo di intervento.</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">2</div>
              <div class="step-title">Preparazione</div>
              <div class="step-text">Prepariamo l’area e i macchinari professionali.</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">3</div>
              <div class="step-title">Sanificazione</div>
              <div class="step-text">Eseguiamo la sanificazione con prodotti certificati.</div>
            </div>
          </div>

          <div class="col">
            <div class="process-step">
              <div class="step-num">4</div>
              <div class="step-title">Certificazione</div>
              <div class="step-text">Rilasciamo la certificazione di avvenuta sanificazione.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">Hai bisogno di sanificare i tuoi spazi?</h2>
      <p class="cta-text">
        Contattaci per un preventivo gratuito. Interveniamo rapidamente con personale specializzato.
      </p>

      <div class="d-flex justify-content-center gap-2 flex-wrap mt-3">
        <button class="btn btn-light cta-btn" (click)="navigateToPreventiviSito()">
          Richiedi preventivo gratuito
        </button>
        <a class="btn btn-outline-light cta-btn" href="tel:08554360">
          Chiama 085 54360
        </a>
      </div>
    </div>
  </section>

  <!-- MAPPA -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head text-center">
        <h2 class="fw-bold">Dove operiamo</h2>
        <p class="text-muted mb-0">Sede commerciale: Via Tirino 145, Pescara.</p>
      </div>

      <div class="col-12 col-md-10 col-lg-8 mx-auto mt-3">
        <div class="ratio ratio-16x9 map-shell">
          <iframe
            loading="lazy"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2843.2073!2d14.2181475!3d42.4462893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1331a6223b8afae7%3A0xe0f8329b5888d54d!2sVia%20Tirino%2C%20145%2C%20Pescara!5e0!3m2!1sit!2sit!4v1713538014550"
            allowfullscreen
            style="border: 0"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </section>

  <!-- WhatsApp -->
  <div class="position-fixed bottom-0 end-0 mb-4 me-4" style="z-index: 1050">
    <a
      href="https://wa.me/3515034934"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatta su WhatsApp"
      class="btn btn-success rounded-circle btn-sm"
    >
      <i class="fa-brands fa-whatsapp fa-2x"></i>
    </a>
  </div>
</main>
